import { StyleObject } from '../../Themes';

export const sidebarWrapperCollapsed = (hasSubItems: any) => {
	return {
		display: 'flex',
		flexFlow: 'column nowrap',
		justifyContent: 'space-between',
		backgroundColor: 'var(--epods--color-white)',
		width: hasSubItems ? 'inherit' : null,
		height: '100%',
	} as StyleObject;
};

export const sidebarTitle = {
	flexGrow: 0,
} as StyleObject;

export const sidebarTopItems = {
	flexGrow: 1,
	maxHeight: '100%',
	overflowX: 'hidden',
	overflowY: 'auto',
} as StyleObject;

export const sidebarTopList = () => {
	return {
		minHeight: '100%',
		maxHeight: '100%',
	} as StyleObject;
};

export const sidebarBottomItems = {
	flexGrow: 0,
	borderTop: '1px solid #f2f2f2',
} as StyleObject;

export const sidbarCollapse = {
	borderTop: '1px solid #f2f2f2',
} as StyleObject;

export const sidebarWrapperExpanded = (alignItems: any) => {
	return {
		display: 'flex',
		flexFlow: 'column nowrap',
		backgroundColor: 'var(--epods--color-white)',
		width: '100%',
		height: '100%',
		textAlign: alignItems,
	} as StyleObject;
};

export const sidebarItem = (collapsed: boolean | undefined) => {
	return {
		borderRight: '4px solid transparent',
		height: 'var(--epods--sidebar-item-height)',
		display: 'flex',
		justifyContent: collapsed ? 'flex-start' : 'center',
		alignItems: 'center',
		position: 'relative',

		':hover': {
			backgroundColor: 'var(--epods--item-hover)',
			borderRight: 'var(--epods--item-hover)',
		},
	} as StyleObject;
};

export const sidebarItemSelected = (collapsed: boolean | undefined) => {
	return {
		backgroundColor: 'var(--epods--color-sidebar-selected-border-left) !important',
		borderRight: '4px solid var(--epods--color-sidebar-selected-border-right)',
		height: 'var(--epods--sidebar-item-height)',
		display: 'flex',
		justifyContent: collapsed ? '' : 'center',
		alignItems: 'center',
		position: 'relative',

		':hover': {
			backgroundColor: 'var(--epods--color-sidebar-selected-border-left) !important',
			borderRight: '4px solid var(--epods--color-sidebar-selected-border-right) !important',
		},
	} as StyleObject;
};

export const title = {
	color: 'var(--epods--color-text-ds-dark)',
	margin: 'var(--epods--space-inset-m) var(--epods--space-inset-m)',
} as StyleObject;

export const separator = (collapsed: boolean | undefined) =>
({
	width: collapsed ? '100%' : 'calc(100% - 2 * var(--epods--space-inset-s))',
	border: 'solid 1px #9daab1',
	margin: collapsed ? '0px 0px' : '0px 0px 0px calc(var(--epods--space-inset-s))',
	borderWidth: '1px 0 0 0',
} as StyleObject);
